<template>
  <div>
    <section class="mb-[80px] px-4">
      <h2 class="bg-white pt-8 text-center text-xl font-normal md:bg-beige1 md:pt-[80px] md:text-2xl">Contact Us</h2>
      <div class="bg-white pb-8 pt-2 md:bg-beige1 md:pb-10"><div class="mx-auto w-12 border-b border-gold1 md:w-14" /></div>
      <div class="bg-white pb-12 md:mx-[5%] md:py-20 e2:m-auto e2:max-w-6xl">
        <div class="text-base md:px-[8%] lg:m-auto lg:max-w-3xl lg:p-0">
          <p class="mb-8 px-2 text-center text-base leading-6 tracking-normal text-black2 md:mb-10">
            If you have any questions, please contact us using the form below.<br class="block md:hidden" />
            We also accept bookings from corporate clients and travel agencies.
          </p>
          <div class="mx-auto w-[270px] md:w-[370px]">
            <AtomsPrimaryButton :on-click="onClickContactUs">Contact us</AtomsPrimaryButton>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { useRouterKey, type UseRouter } from '@/injectionKeys';

const props = defineProps<{
  experienceSlug: string;
}>();

const injectedUseRouter = inject(useRouterKey) as UseRouter;
const router = injectedUseRouter();
const onClickContactUs = () => {
  router.push(`/contact/?experience=${props.experienceSlug}`);
};
</script>
